export default class Text {

	static trimNotWithinWords(text: string, limit = 250): string {
		const trimmedString = text.substr(0, limit);
		return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
	}
}
